import { motion } from "framer-motion";

export default function LogoSwap({ size = "sm", animated = false }) {
  const sizes = {
    xs: { swap: "text-lg", talence: "text-xs", line: "h-0.5 w-8" },
    sm: { swap: "text-xl", talence: "text-sm", line: "h-0.5 w-10" },
    md: { swap: "text-2xl", talence: "text-base", line: "h-0.5 w-12" },
    lg: { swap: "text-4xl", talence: "text-xl", line: "h-0.5 w-16" },
  };
  const s = sizes[size] || sizes.sm;

  return (
    <div className="inline-flex flex-col items-start leading-none">
      <span className={`font-extrabold text-foreground tracking-tight ${s.swap}`}>Swap</span>
      <div className="flex flex-col items-start">
        <span className={`font-semibold text-coral-600 ${s.talence}`} style={{ color: "#FF6B4A" }}>Talence</span>
        {animated ? (
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ delay: 0.3, duration: 0.4, ease: "easeOut" }}
            className={`${s.line} bg-lime-400 rounded-full origin-left mt-0.5`}
            style={{ backgroundColor: "#B9F85A" }}
          />
        ) : (
          <div className={`${s.line} rounded-full mt-0.5`} style={{ backgroundColor: "#B9F85A" }} />
        )}
      </div>
    </div>
  );
}